import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "ControlGLReconciliationModelerGlobal" })(
  (_theme) => ({
    page: {
      margin: "20px",
    },
    controlGLReconciliationModelerGlobalExportBtn: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: "10px",
      marginTop: "-30px",
    },
  }),
);
